<script>
    import Util from 'util/util'

    const {
        settings,
    } = $props()
</script>

<section>
    <div>
        <span class="label">{window.i18n.gettext('Grading mode')}:</span>
        {settings.gradingMode}
    </div>
    {#if settings.gradingStrictness}
        <div>
            <span class="label">{window.i18n.gettext('Spelling')}:</span>
            {settings.gradingStrictness}
        </div>
    {/if}

    <!-- Only number the items when there are multiple gaps/inputs -->
    {#if settings.items.length === 1}
        {@render item(settings.items[0])}
    {:else}
        <ol>
            {#each settings.items as listItem, index (index)}
                <li>{@render item(listItem)}</li>
            {/each}
        </ol>
    {/if}
</section>

{#snippet item({ modelAnswer, isHtml, alternatives, rules, type })}
    <div class="item">
        <div>
            {#if type}
                <span class="label">{type}:</span>
            {/if}
            <span class="model-answer">
                {#if !modelAnswer}
                    <i>{window.i18n.gettext('Empty answer')}</i>
                {:else if isHtml}
                    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
                    {@html Util.renderContentSafely(modelAnswer)}
                {:else}
                    {modelAnswer}
                {/if}
            </span>
        </div>
        {#if alternatives.length}
            <div>
                <span class="label">{window.i18n.gettext('Alternatives')}:</span>
                {alternatives.join(' · ')}
            </div>
        {/if}
        {#each rules ?? [] as rule (rule)}
            <div>{rule}</div>
        {/each}
    </div>
{/snippet}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
section {
  border: solid 1px hsl(40, 4%, 84%);
  background: #fff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  gap: 12px;
  margin-bottom: 16px;
}

ol {
  display: grid;
  gap: 8px;
  margin: 0;
  padding-left: 24px;
}

.model-answer {
  font-weight: 600;
}
.model-answer :global(p) {
  margin: 0;
}

.label {
  color: rgba(18, 45, 64, 0.8);
}</style>
